import React from 'react';
import { useAccount } from '@/hooks/useAccount';
import { useUser } from '@repo/hooks/useUser';
import { MainView, NoAccessView } from '@repo/ui/Views';
import UsersTable from '../components/UsersTable';
import { POLICIES } from '@/lib/Authorization';

const Users = () => {
  const account = useAccount();
  const accountId = account.id;

  const user = useUser();

  return POLICIES['user:index'](user) ? (
    <MainView
      title="Users"
      cta={
        POLICIES['user:create'](user)
          ? {
              cta: true,
              ctaHref: `/a/${accountId}/users/create-user`,
              ctaText: 'Create new user',
            }
          : false
      }
    >
      <UsersTable accountId={Array.isArray(accountId) ? accountId[0] : accountId} />
    </MainView>
  ) : (
    <NoAccessView />
  );
};

export default Users;
